import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteSectorSaga,
  getSectorDetailsSaga,
  getSectorListSaga,
} from "src/store/sectors/saga";
import { SectorDetailDto, SectorDto } from "src/store/sectors/type";
import SectorCreateForm from "./create";
import SectorEditForm from "./edit";
const SectorPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<SectorDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<SectorDetailDto>();
  const columns = [
    {
      text: t("Sector.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Sector.PageTitle")}
        metaTag={t("Sector.MetaTag")}
        gridProps={{
          addTitle: t("Sector.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getSectorListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getSectorDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: SectorDto) =>
              t("Sector.DeleteQA", {
                name: data.Name,
              }),
            action: deleteSectorSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <SectorCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getSectorListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <SectorEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getSectorListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default SectorPage;
